import React, { useEffect, useMemo, useState } from "react";
import { getPublishers } from "../../api";
import useGoToPricing from "../../hooks/useGoToPricing";
import { isLoggedIn } from "../../utils/isLoggedIn";
import { scrollPageToTop } from "../../utils/scrollPageToTop";
import Header from "../Homepage/sections/Header";
import Footer from "../Homepage/sections/Footer";
import { HomepageGlobalStyles } from "../Homepage/styles";
import AnalystCard from "./AnalystCard";
import AnalystsFeedSkeleton from "./AnalystsFeedSkeleton";
import {
  AnalystsGrid,
  AnalystsGridInner,
  AnalystsGridSection,
  AnalystsHeaderInner,
  AnalystsHeaderSection,
  AnalystsLead,
  AnalystsPage,
  AnalystsTitle,
} from "./Analysts.styles";

/**
 * Lovable shell for Analysts directory. Prod: getPublishers(), isHidden filter,
 * isFeaturedContributor ribbon, stripHtml bio, /analyst/:slug links.
 */
const Analysts = () => {
  const goToPricing = useGoToPricing();
  const loggedIn = isLoggedIn();
  const [publishers, setPublishers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    scrollPageToTop();
  }, []);

  useEffect(() => {
    let cancelled = false;

    const loadPublishers = async () => {
      setLoading(true);
      try {
        const response = await getPublishers();
        if (!cancelled) {
          setPublishers(response?.data || []);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadPublishers();

    return () => {
      cancelled = true;
    };
  }, []);

  const visiblePublishers = useMemo(
    () => (publishers || []).filter((publisher) => publisher.isHidden === false),
    [publishers]
  );

  return (
    <AnalystsPage>
      <HomepageGlobalStyles />
      <Header onSubscribeClick={goToPricing} hideSpacer />

      <AnalystsHeaderSection>
        <AnalystsHeaderInner>
          <AnalystsTitle>
            Our World-Class <span>Analyst Team</span>
          </AnalystsTitle>
          <AnalystsLead>
            Seven seasoned experts delivering institutional-grade Bitcoin and crypto
            commentary.
          </AnalystsLead>
        </AnalystsHeaderInner>
      </AnalystsHeaderSection>

      <AnalystsGridSection aria-label="Analysts">
        <AnalystsGridInner>
          {loading ? (
            <AnalystsFeedSkeleton />
          ) : (
            <AnalystsGrid>
              {visiblePublishers.map((publisher) => (
                <AnalystCard key={publisher.id} publisher={publisher} />
              ))}
            </AnalystsGrid>
          )}
        </AnalystsGridInner>
      </AnalystsGridSection>

      <Footer onSubscribeClick={goToPricing} hideSubscribeCta={loggedIn} />
    </AnalystsPage>
  );
};

export default Analysts;
